import { Loader2 } from "lucide-react";
import { forwardRef } from "react";

/**
 * Drop-in button with built-in loading spinner.
 * Renders children inline; when loading, replaces them with loadingText.
 */
const LoadingButton = forwardRef(function LoadingButton(
  { loading, disabled, children, className = "", loadingText, type = "button", ...rest },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      disabled={loading || disabled}
      aria-busy={loading || undefined}
      className={
        "inline-flex items-center justify-center gap-2 transition disabled:opacity-60 disabled:cursor-not-allowed " +
        className
      }
      {...rest}
    >
      {loading ? (
        <>
          <Loader2 size={14} className="animate-spin" aria-hidden />
          {loadingText || "Memproses…"}
        </>
      ) : (
        children
      )}
    </button>
  );
});

export default LoadingButton;
